module.exports = __webpack_public_path__ + "images/51c608eee77dcbdd1be5e27435a8cfd2f2da3d5fc30fb948abf29ed6944ac531.svg";